import useFrontendConfigurationShim from '@rover/shared/js/hooks/useFrontendConfigurationShim';

import Trustpilot, { TrustPilotProps } from './Trustpilot';

type Props = Omit<TrustPilotProps, 'languageCode'>;

const TrustPilotContainer: React.FC<Props> = (props: Props) => {
  const { language = 'en-us' } = useFrontendConfigurationShim();
  return <Trustpilot languageCode={language} {...props} />;
};

export default TrustPilotContainer;
